import { Box, Grid, Typography, styled, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import FancyCard from "components/FancyCard";
import { GetReferralIsNotPaid } from "store/api/referral";
import ItemUsersStatistic from "./Component/ItemUsersStatistic";
import http from "config/http";
import useNotify from "hooks/useNotify";
import NumberFormats from "components/NumberFormats";
import CardSkeleton from "components/Skeletons/Card.Skeleton";

const tomanURL = `/images/coin/toman.png`;

function UsersStatistic() {
  const [referralIsNotPaid, setReferralIsNotPaid] = useState();
  const notify = useNotify();
  const theme = useTheme();

  const getReferralIsNotPaid = async () => {
    try {
      const { data } = await http.get(GetReferralIsNotPaid);
      setReferralIsNotPaid(data?.data);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getReferralIsNotPaid();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {referralIsNotPaid ? (
        <Grid item xs={12}>
          <FancyCard color={theme.palette.primary.alternate}>
            <BoxTitle>
              <Typography component="p">
                <Typography
                  variant="subtitle1"
                  fontWeight={300}
                  color="common.white"
                >
                  {referralIsNotPaid?.date}
                </Typography>

                <Typography
                  textAlign="left"
                  variant="subtitle1"
                  fontWeight={300}
                  color="common.white"
                >
                  {referralIsNotPaid?.time}
                </Typography>
              </Typography>

              <Typography variant="h4" color="common.white" textAlign="right">
                آمار کاربران معرفی شده توسط شما
              </Typography>
            </BoxTitle>

            <Grid container spacing={2} flexDirection="row-reverse">
              <Grid item md={4} sm={6} xs={12}>
                <ItemUsersStatistic
                  title={"مقدار رفرال برگشتی"}
                  value={`${referralIsNotPaid?.sumAmountParent || 0} معامله`}
                />

                <ItemUsersStatistic
                  title={"تعداد مبادلات برگشتی"}
                  value={`${referralIsNotPaid?.countParent || 0} معامله`}
                />
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <ItemUsersStatistic
                  title={"مقدار رفرال دوستان"}
                  value={referralIsNotPaid?.sumAmountChild || 0}
                />

                <ItemUsersStatistic
                  title={" تعداد مبادلات دوستان"}
                  value={referralIsNotPaid?.countChild || 0}
                />
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography
                  textAlign="right"
                  variant="h6"
                  component="p"
                  color="common.white"
                  paddingBottom={3}
                >
                  مجموع مقدار رفرال شما
                </Typography>

                <BoxSumAmountAll>
                  <img src={DefaultUrlWeb + tomanURL} alt="USDT" />

                  <Typography
                    variant="h4"
                    color="common.white"
                    paddingLeft={1.3}
                    paddingRight={1.3}
                  >
                    <NumberFormats
                      value={referralIsNotPaid?.sumAmountAll || 0}
                    />
                  </Typography>

                  <Typography
                    variant="h6"
                    color="common.white"
                    fontWeight={300}
                  >
                    TOMAN
                  </Typography>
                </BoxSumAmountAll>
              </Grid>
            </Grid>
          </FancyCard>
        </Grid>
      ) : (
        <CardSkeleton heightSize={210} />
      )}
    </>
  );
}
const BoxTitle = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  display: "flex",
  justifyContent: "space-between",
  direction: "ltr",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

const BoxSumAmountAll = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  img: {
    width: "24px",
    height: "24px",
  },
}));

export default UsersStatistic;
